import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuitIcon, CarIcon, HomeIcon, BriefcaseIcon, SettingsIcon, Trash2Icon, SparklesIcon, ShieldIcon } from 'lucide-react';
const preferences = [{
  category: 'Cars',
  icon: CarIcon,
  items: ['Toyota, Nissan, Lexus', 'Under AED 100,000', 'GCC Specs only', 'SUV or Sedan']
}, {
  category: 'Property',
  icon: HomeIcon,
  items: ['Dubai Marina, JLT, Al Barsha', 'Near Metro Station', '2-3 Bedrooms', 'Pet friendly']
}, {
  category: 'Jobs',
  icon: BriefcaseIcon,
  items: ['Marketing Manager', 'Remote or Hybrid', 'AED 20k+ Expected']
}];
const aiInsights = ['Prado prices dropped 5% this week in your preferred areas.', 'Your property budget may fit Arjan better than Al Barsha based on recent trends.', 'A new Marketing Manager role matches your experience perfectly.'];
export function MyAI() {
  return <div className="flex-1 p-4 lg:p-8 max-w-4xl mx-auto w-full" data-id="element-5762" data-mp="1c0uqdoj3h7r7">
      <div className="flex items-center gap-4 mb-8" data-id="element-5763" data-mp="1c2eaxrbsa4ys">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-indigo to-ai-purple flex items-center justify-center shadow-lg" data-id="element-5764" data-mp="1g1ep2wjbgjfg">
          <BrainCircuitIcon className="w-8 h-8 text-white" data-id="element-5765" data-mp="1kzye55t7ibc1" />
        </div>
        <div data-id="element-5766" data-mp="1q15kd0fpb2gl">
          <h1 className="font-display font-bold text-3xl text-dark-navy mb-1" data-id="element-5767" data-mp="1q1xcg1a3ai24">
            My AI Memory
          </h1>
          <p className="text-slate-500" data-id="element-5768" data-mp="1uxcoqosg85wf">
            What Talab knows about your preferences to give you better matches.
          </p>
        </div>
      </div>

      {/* AI Insights */}
      <div className="bg-gradient-to-br from-primary-indigo/5 via-ai-purple/5 to-electric-cyan/5 rounded-3xl p-6 lg:p-8 border border-primary-indigo/10 ai-glow mb-8" data-id="element-5769" data-mp="23siytzyr5a4r">
        <div className="flex items-center gap-3 mb-6" data-id="element-5770" data-mp="2dqztp80ta8w3">
          <SparklesIcon className="w-6 h-6 text-ai-purple" data-id="element-5771" data-mp="2ip1dxw9z4e95" />
          <h2 className="font-display font-bold text-xl text-dark-navy" data-id="element-5772" data-mp="2ipjgtbr55qq1">
            Latest Insights for You
          </h2>
        </div>
        <div className="space-y-4" data-id="element-5773" data-mp="1o1t4a9de8c26">
          {aiInsights.map((insight, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-white/40 shadow-sm" data-id="element-5774" data-mp="1nzosl59968rc" data-mpi={idx}>
              <p className="text-slate-700 font-medium" data-id="element-5775" data-mp="2lq37grox15uv">{insight}</p>
            </motion.div>)}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-5776" data-mp="2grrx8fupktc4">
        {/* Preferences */}
        <div className="space-y-6" data-id="element-5777" data-mp="rck5n5nur13r">
          <h2 className="font-display font-bold text-xl text-dark-navy flex items-center gap-2" data-id="element-5778" data-mp="rdmul81m6th1">
            <SettingsIcon className="w-5 h-5 text-slate-400" data-id="element-5779" data-mp="meim6jmikzrr" />
            Learned Preferences
          </h2>

          <div className="space-y-4" data-id="element-5780" data-mp="2y25buh338yit">
            {preferences.map((pref, idx) => {
            const Icon = pref.icon;
            return <div key={idx} className="bg-white rounded-2xl p-5 border border-slate-200 shadow-sm" data-id="element-5781" data-mp="2o8y9l53n9ymy" data-mpi={idx}>
                  <div className="flex items-center gap-3 mb-4" data-id="element-5782" data-mp="2f9b5ucng0gqq">
                    <div className="p-2 bg-slate-100 rounded-lg" data-id="element-5783" data-mp="2f800i8ecn0xi">
                      <Icon className="w-5 h-5 text-slate-600" data-id="element-5784" data-mp="2jb4zw234umhx" />
                    </div>
                    <h3 className="font-bold text-slate-900" data-id="element-5785" data-mp="25bx0b8325cd7">
                      {pref.category}
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-5786" data-mp="2aagl355x0i3z">
                    {pref.items.map((item, i) => <span key={i} className="px-3 py-1.5 bg-slate-50 border border-slate-100 rounded-lg text-sm text-slate-600" data-id="element-5787" data-mp="3hxpsoxrez1k" data-mpi={i}>
                        {item}
                      </span>)}
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* Privacy Controls */}
        <div className="space-y-6" data-id="element-5788" data-mp="1qmh1siap2gf1">
          <h2 className="font-display font-bold text-xl text-dark-navy flex items-center gap-2" data-id="element-5789" data-mp="1ql5p1sz9tybs">
            <ShieldIcon className="w-5 h-5 text-slate-400" data-id="element-5790" data-mp="1lo5p7zt0lrt4" />
            Privacy & Control
          </h2>

          <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-6" data-id="element-5791" data-mp="1gvm3ugo35sdr">
            <div data-id="element-5792" data-mp="1by42pcgb8hgb">
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-5793" data-mp="1bxkl5wuknv2t">
                What Talab remembers
              </h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-5794" data-mp="17twb97igwnee">
                Talab uses your chat history and saved items to understand your
                preferences and improve match scores.
              </p>
              <label className="flex items-center justify-between p-3 bg-slate-50 rounded-xl cursor-pointer" data-id="element-5795" data-mp="39kvglnapurre">
                <span className="text-sm font-medium text-slate-700" data-id="element-5796" data-mp="3ejpxukt1c89e">
                  Enable AI Memory
                </span>
                <div className="relative inline-block w-10 h-6 rounded-full bg-primary-indigo" data-id="element-5797" data-mp="3jk45w2umzi7f">
                  <span className="absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform translate-x-4" data-id="element-5798" data-mp="3njmqexijpr9q" />
                </div>
              </label>
            </div>

            <div className="pt-4 border-t border-slate-100" data-id="element-5799" data-mp="2vsyrls4cgxz8">
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-5800" data-mp="2vr44q89iivsi">Data Sharing</h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-5801" data-mp="2ztikgjhvxffk">
                Allow Talab to share anonymous preferences with verified sellers
                to get better offers.
              </p>
              <label className="flex items-center justify-between p-3 bg-slate-50 rounded-xl cursor-pointer" data-id="element-5802" data-mp="283e5j0cw9klq">
                <span className="text-sm font-medium text-slate-700" data-id="element-5803" data-mp="2c3oe8ks2mp4a">
                  Share anonymous data
                </span>
                <div className="relative inline-block w-10 h-6 rounded-full bg-slate-300" data-id="element-5804" data-mp="3ahbtumjwjj3r">
                  <span className="absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform" data-id="element-5805" data-mp="3p687cz4q9obr" />
                </div>
              </label>
            </div>

            <div className="pt-4 border-t border-slate-100" data-id="element-5806" data-mp="3k7wwqm6lz9sh">
              <button className="flex items-center gap-2 text-error hover:bg-error/5 px-4 py-2 rounded-lg transition-colors w-full justify-center font-medium" data-id="element-5807" data-mp="2wgr9hlyc9f85">
                <Trash2Icon className="w-4 h-4" data-id="element-5808" data-mp="2rksl3yd0fx7q" />
                Clear AI Memory
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}